import React, { PureComponent } from 'react';
import ReactTable from 'react-table';

import { TableWrapper } from 'modules/list/table';
import { rmStateOptions } from 'constants/form';
import { filterOptionsLabel } from 'utils';

class ParentRelationshipManagers extends PureComponent {
  render() {
    const { tableData } = this.props;

    const tableColumns = [
      {
        Header: `Relationship Managers - ${tableData.length}`,
        columns: [
          {
            Header: 'Name',
            id: 'name',
            accessor: d => `${d.first_name} ${d.last_name}`,
            width: 150,
          },
          {
            Header: 'Buisness Phone',
            accessor: 'rm_business_phone_number',
            width: 150,
          },
          {
            Header: 'Email',
            accessor: 'email',
            width: 250,
          },
          {
            Header: 'RM Manager',
            id: 'rm_manager',
            accessor: d =>
              d.manager ? `${d.manager.first_name} ${d.manager.last_name}` : '',
            width: 150,
          },
          {
            Header: 'Status',
            id: 'state',
            accessor: d => (d.state ? filterOptionsLabel(rmStateOptions, d.state) : ''),
            width: 150,
          },
          {
            Header: 'RM Region',
            accessor: 'rm_region',
            width: 150,
          },
          {
            Header: 'RM Timezones',
            id: 'rm_timezones',
            accessor: d =>
              d.rm_timezones && d.rm_timezones.length > 0
                ? d.rm_timezones.toString()
                : '',
            width: 150,
          },
          {
            Header: 'RM Weight',
            accessor: 'round_robin_weight',
            width: 100,
          },
          {
            Header: 'Total Assigned Parents',
            accessor: 'total_assigned_parents',
            width: 150,
          },
        ],
      },
    ];

    return (
      <TableWrapper>
        <ReactTable
          data={tableData}
          className="-striped -highlight"
          manual
          showPaginationTop
          showPageSizeOptions={false}
          filterable={false}
          sortable={false}
          resizable={false}
          defaultPageSize={20}
          columns={tableColumns}
          style={{ textAlign: 'center' }}
        />
      </TableWrapper>
    );
  }
}
export default ParentRelationshipManagers;
